var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5263 64H25.8947V40.0971L8.63158 49.0544V64H0V44.0165L34.5263 26.1053V64Z",
    fill: "#FC6011"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42105 14.1664V0H0V18.5263L8.42105 14.1664Z",
    fill: "#FFC0A1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8947 0V14.9456L25.767 15.0128L25.7946 15.0598L16.5519 19.792L8.63158 23.9029V23.8492L0 28.2724V37.8947L34.5263 19.9835V0H25.8947Z",
    fill: "#FFC0A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.58641d05755885997d6b4b3e34792385.svg";
export { ForwardRef as ReactComponent };